import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default class Checkbox extends Component {
  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    hidden: PropTypes.bool
  }

  onChange = (event) => {
    this.props.onChange(event.target.checked)
  }

  render () {
    return (
      <div className='form-inputs'>
        <div className='form-input form-input--no-margin check_boxes has-padding'>
          <div className='form-controls'>
            <div className='form-controls__controls'>
              <label className='form-control' htmlFor={this.props.id}>
                <input className='check_boxes' type={this.props.hidden ? 'hidden' : 'checkbox'}
                  onChange={this.onChange}
                  defaultValue={this.props.value}
                  name={this.props.name}
                  id={this.props.id} />
                <span className='form-control__indicator' />
                <span className='form-control__label'>{this.props.label}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
